import { c as _c } from "react/compiler-runtime";
import React from "react";
interface HeaderSearchTabOption {
  readonly key: string;
  readonly label: string;
  readonly hasIndicator?: boolean | undefined;
  readonly panelId: string;
}
interface HeaderSearchTabToggleProps {
  readonly options: readonly HeaderSearchTabOption[];
  readonly activeKey: string;
  readonly onSelect: (key: string) => void;
  readonly fullWidth?: boolean | undefined;
  readonly orientation?: "horizontal" | "vertical" | undefined;
}
export const HeaderSearchTabToggle: React.FC<HeaderSearchTabToggleProps> = t0 => {
  const $ = _c(14);
  const {
    options,
    activeKey,
    onSelect,
    fullWidth: t1,
    orientation: t2
  } = t0;
  const fullWidth = t1 === undefined ? false : t1;
  const orientation = t2 === undefined ? "horizontal" : t2;
  const isVertical = orientation === "vertical";
  const directionClasses = isVertical ? "tw-flex-col tw-gap-y-1.5" : "tw-gap-1";
  let widthClasses;
  if (isVertical) {
    widthClasses = "";
  } else {
    if (fullWidth) {
      widthClasses = "tw-w-full";
    } else {
      widthClasses = "tw-w-auto";
    }
  }
  const t3 = `${"tw-flex"} ${directionClasses} ${widthClasses}`;
  let t4;
  if ($[0] !== t3) {
    t4 = t3.trim();
    $[0] = t3;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  const containerClasses = t4;
  let t5;
  if ($[2] !== activeKey || $[3] !== isVertical || $[4] !== onSelect || $[5] !== options) {
    let t6;
    if ($[7] !== activeKey || $[8] !== isVertical || $[9] !== onSelect) {
      t6 = option => <button key={option.key} onClick={() => onSelect(option.key)} role="tab" aria-selected={activeKey === option.key} aria-controls={option.panelId} className={`tw-whitespace-nowrap tw-text-sm tw-font-medium tw-transition-all tw-duration-150 tw-relative focus:tw-outline-none tw-border-none tw-rounded-sm ${isVertical ? "tw-flex tw-items-center tw-justify-start tw-w-full tw-py-2 tw-pl-3" : "tw-flex-1 tw-text-center tw-py-2"} ${activeKey === option.key ? "tw-bg-white tw-text-black" : "tw-text-white tw-bg-transparent hover:tw-bg-iron-800"}`}>{option.label}{option.hasIndicator && <div className="tw-absolute tw-rounded-full -tw-right-1 tw-top-1 tw-bg-red tw-h-2 tw-w-2" />}</button>;
      $[7] = activeKey;
      $[8] = isVertical;
      $[9] = onSelect;
      $[10] = t6;
    } else {
      t6 = $[10];
    }
    t5 = options.map(t6);
    $[2] = activeKey;
    $[3] = isVertical;
    $[4] = onSelect;
    $[5] = options;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[11] !== containerClasses || $[12] !== t5) {
    t6 = <div className={containerClasses} role="tablist">{t5}</div>;
    $[11] = containerClasses;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  return t6;
};